import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DownloadIcon from '@mui/icons-material/Download';

import ToolboxHeader from '../../../ToolboxHeader';
import ScrollableContainer from '../../../../../../../components/ScrollableContainer';

import { useMytaverseEvent } from '../../../../../providers';

import { formatTime, getESTDate } from '../../../../../../../helpers/datetime';
import { downloadImage } from '../../../../../../../helpers/download';

import { IAgenda } from './interfaces';

import { useStyles } from './styles';
import { useNotification } from '../../../../../../../components/Notification';

const Agenda = ({ context }: IAgenda) => {
  const classes = useStyles();

  const { currentEvent } = useMytaverseEvent();
  const { t: translate } = useTranslation('common');
  const { showNotification, getBadRequestNotification } = useNotification();

  const handleClick = async () => {
    try {
      await downloadImage(currentEvent?.agendaImage || '');
    } catch (e) {
      showNotification(
        getBadRequestNotification({
          message: translate('toolbox.downloadAgendaError'),
        }),
      );
    }
  };

  return (
    <Box sx={classes.root}>
      <ToolboxHeader {...context} />
      <Box sx={classes.header}>
        <Typography sx={classes.time}>
          <ScheduleIcon />
          {formatTime(getESTDate())} EST
        </Typography>
        <Button
          sx={classes.button}
          disableRipple
          variant="text"
          onClick={handleClick}
        >
          <DownloadIcon />
          {translate('toolbox.downloadAgenda')}
        </Button>
      </Box>
      <ScrollableContainer
        sxProps={{ root: classes.image, content: classes.imageContent }}
      >
        <img
          src={currentEvent?.agendaImage}
          alt={translate('tooltip.agenda')}
        />
      </ScrollableContainer>
    </Box>
  );
};

export default Agenda;
